import {lazy} from 'react';

const loadModule = () => import('./routes/ModuleRoutes');
export const RegisterTracesModule = lazy(loadModule);

export default RegisterTracesModule;
